import { Controller } from "@hotwired/stimulus"

// AED amount input: shows thousands separators when idle, raw digits while
// editing. The server parses the comma-separated string with BigDecimal
// (MoneyParams#to_fils) — this is display sugar only.
export default class extends Controller {
  connect() {
    this.format()
  }

  focus() {
    this.element.value = this.element.value.replaceAll(",", "")
  }

  format() {
    const raw = this.element.value.replaceAll(",", "").trim()
    if (raw === "") return
    const number = Number.parseFloat(raw)
    if (!Number.isFinite(number)) return
    this.element.value = number.toLocaleString("en-AE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
}
